'use strict';

var fieldUtils = require('../utils/field.utils');

module.exports = {
    onPassengerPageComplete: function(data, hasErrors, widgetData, $page) {
        if (data.errors) {
            fieldUtils.scrollToFirstError($page);
        } else {
            widgetData[data.widgetId] = widgetData[data.widgetId] || {};
            Odigeo._.extend(widgetData[data.widgetId], data.data);
        }
        return {
            hasErrors: data.errors ? true : false,
            widgetData,
        };
    },
    validatePassengersManager: function($widgetToFind) {
        Odigeo._.each($widgetToFind, function(el) {
            Odigeo.requireWidget($(el).data('id'), $(el).data('widget'), function(widget) {
                widget.execute('validate');
            });
        });
    },
    getBuyerInfoDto: function($widgetToFind) {
        let buyerDTO;
        Odigeo._.each($widgetToFind, function(el) {
            Odigeo.requireWidget($(el).data('id'), $(el).data('widget'), function(widget) {
                buyerDTO = widget.get('getBuyerDTO');
            });
        });
        return buyerDTO;
    },
};
